import al from '../../../../../assets/flags/europe/al.png'; // Albania
import ad from '../../../../../assets/flags/europe/ad.png'; // Andorra
import at from '../../../../../assets/flags/europe/at.png'; // Austria
import by from '../../../../../assets/flags/europe/by.png'; // Belarus
import be from '../../../../../assets/flags/europe/be.png'; // Belgium
import ba from '../../../../../assets/flags/europe/ba.png'; // Bosnia and Herzegovina
import bg from '../../../../../assets/flags/europe/bg.png'; // Bulgaria
import hr from '../../../../../assets/flags/europe/hr.png'; // Croatia
import cy from '../../../../../assets/flags/europe/cy.png'; // Cyprus
import cz from '../../../../../assets/flags/europe/cz.png'; // Czech Republic
import dk from '../../../../../assets/flags/europe/dk.png'; // Denmark
import ee from '../../../../../assets/flags/europe/ee.png'; // Estonia
import fi from '../../../../../assets/flags/europe/fi.png'; // Finland
import fr from '../../../../../assets/flags/europe/fr.png'; // France
import fo from '../../../../../assets/flags/europe/fo.png'; // Faroe Islands
import de from '../../../../../assets/flags/europe/de.png'; // Germany
import ge from '../../../../../assets/flags/europe/ge.png'; // Georgia
import gr from '../../../../../assets/flags/europe/gr.png'; // Greece
import hu from '../../../../../assets/flags/europe/hu.png'; // Hungary
import is from '../../../../../assets/flags/europe/is.png'; // Iceland
import ie from '../../../../../assets/flags/europe/ie.png'; // Ireland
import it from '../../../../../assets/flags/europe/it.png'; // Italy
import lv from '../../../../../assets/flags/europe/lv.png'; // Latvia
import li from '../../../../../assets/flags/europe/li.png'; // Liechtenstein
import lt from '../../../../../assets/flags/europe/lt.png'; // Lithuania
import lu from '../../../../../assets/flags/europe/lu.png'; // Luxembourg
import mt from '../../../../../assets/flags/europe/mt.png'; // Malta
import md from '../../../../../assets/flags/europe/md.png'; // Moldova
import mc from '../../../../../assets/flags/europe/mc.png'; // Monaco
import me from '../../../../../assets/flags/europe/me.png'; // Montenegro
import nl from '../../../../../assets/flags/europe/nl.png'; // Netherlands
import mk from '../../../../../assets/flags/europe/mk.png'; // North Macedonia
import no from '../../../../../assets/flags/europe/no.png'; // Norway
import pl from '../../../../../assets/flags/europe/pl.png'; // Poland
import pt from '../../../../../assets/flags/europe/pt.png'; // Portugal
import ro from '../../../../../assets/flags/europe/ro.png'; // Romania
import ru from '../../../../../assets/flags/europe/ru.png'; // Russia
import sm from '../../../../../assets/flags/europe/sm.png'; // San Marino
import rs from '../../../../../assets/flags/europe/rs.png'; // Serbia
import sk from '../../../../../assets/flags/europe/sk.png'; // Slovakia
import si from '../../../../../assets/flags/europe/si.png'; // Slovenia
import es from '../../../../../assets/flags/europe/es.png'; // Spain
import se from '../../../../../assets/flags/europe/se.png'; // Sweden
import ch from '../../../../../assets/flags/europe/ch.png'; // Switzerland
import tr from '../../../../../assets/flags/europe/tr.png'; // Turkey
import ua from '../../../../../assets/flags/europe/ua.png'; // Ukraine
import gb from '../../../../../assets/flags/europe/gb.png'; // United Kingdom
import va from '../../../../../assets/flags/europe/va.png'; // Vatican City

export const FLAGS = [
    al,   // Albania (0)
    ba,   // Bosnia and Herzegovina (1)
    bg,   // Bulgaria (2)
    cy,   // Cyprus (3)
    dk,   // Denmark (4)
    ie,   // Ireland (5)
    ee,   // Estonia (6)
    at,   // Austria (7)
    cz,   // Czech Republic (8)
    fi,   // Finland (9)
    fr,   // France (10)
    ge,   // Georgia (11)
    de,   // Germany (12)
    gr,   // Greece (13)
    hr,   // Croatia (14)
    hu,   // Hungary (15)
    is,   // Iceland (16)
    it,   // Italy (17)
    lv,   // Latvia (18)
    by,   // Belarus (19)
    lt,   // Lithuania (20)
    sk,   // Slovakia (21)
    li,   // Liechtenstein (22)
    mk,   // North Macedonia (23)
    mt,   // Malta (24)
    be,   // Belgium (25)
    fo,   // Faroe Islands (26)
    ad,   // Andorra (27)
    lu,   // Luxembourg (28)
    mc,   // Monaco (29)
    me,   // Montenegro (30)
    nl,   // Netherlands (31)
    no,   // Norway (32)
    pl,   // Poland (33)
    pt,   // Portugal (34)
    ro,   // Romania (35)
    md,   // Moldova (36)
    si,   // Slovenia (37)
    es,   // Spain (38)
    se,   // Sweden (39)
    ch,   // Switzerland (40)
    tr,   // Turkey (41)
    gb,   // United Kingdom (42)
    ua,   // Ukraine (43)
    sm,   // San Marino (44)
    rs,   // Serbia (45)
    va,   // Holy See (Vatican City) (46)
    ru    // Russia (47)
];

export const COUNTRY_INDEX_TO_FLAG_INDEX = [
    [0], [1], [2], [3], [4], [5], [6], [7], [8], [9], [10], [11], [12], [13], [14], [15], [16], [17], 
    [18], [19], [20], [21], [22], [23], [24], [25], [26], [27], [28], [29], [30], [31], [32], [33], 
    [34], [35], [36], [37], [38], [39], [40], [41], [42], [43], [44], [45], [46], [47]
];
